import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Tooltip,
  IconButton,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface OptionVisaComponentProps {
  optionalServices: {
    EnlevementParis: boolean;
    LivraisonParis: boolean;
    RetourDHL: boolean;
    TraitementVIP: boolean;
    SaisieFormulaire: boolean;
  };
  setOptionalServices: React.Dispatch<
    React.SetStateAction<{
      EnlevementParis: boolean;
      LivraisonParis: boolean;
      RetourDHL: boolean;
      TraitementVIP: boolean;
      SaisieFormulaire: boolean;
    }>
  >;
}

const OptionVisaComponent: React.FC<OptionVisaComponentProps> = ({
  optionalServices,
  setOptionalServices,
}) => {
  const { t } = useTranslation('formulaires');

  const SERVICE_PRICES = {
    EnlevementParis: 49,
    LivraisonParis: 49,
    RetourDHL: 49,
    TraitementVIP: 49,
    SaisieFormulaire: 39,
  };

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    optionName: keyof typeof optionalServices
  ) => {
    setOptionalServices((prev) => ({
      ...prev,
      [optionName]: event.target.checked,
    }));
  };

  const renderLabelWithTooltip = (
    label: string,
    price: number,
    tooltipText: string
  ) => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {`${label} ${price}€`}
      <Tooltip title={tooltipText} arrow>
        <IconButton size="small" sx={{ ml: 0.5 }}>
          <HelpOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <Box
      sx={{
        border: '1px solid #ccc',
        borderRadius: 2,
        p: 2,
        mb: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
        {t('options.title')}
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={optionalServices.EnlevementParis}
            onChange={(e) => handleCheckboxChange(e, 'EnlevementParis')}
          />
        }
        label={renderLabelWithTooltip(
          t('options.pickupFile.label'),
          SERVICE_PRICES.EnlevementParis,
          t('options.pickupFile.tooltip')
        )}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={optionalServices.LivraisonParis}
            onChange={(e) => handleCheckboxChange(e, 'LivraisonParis')}
          />
        }
        label={renderLabelWithTooltip(
          t('options.deliveryPassport.label'),
          SERVICE_PRICES.LivraisonParis,
          t('options.deliveryPassport.tooltip')
        )}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={optionalServices.RetourDHL}
            onChange={(e) => handleCheckboxChange(e, 'RetourDHL')}
          />
        }
        label={renderLabelWithTooltip(
          t('options.returnDHL.label'),
          SERVICE_PRICES.RetourDHL,
          t('options.returnDHL.tooltip')
        )}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={optionalServices.SaisieFormulaire}
            onChange={(e) => handleCheckboxChange(e, 'SaisieFormulaire')}
          />
        }
        label={renderLabelWithTooltip(
          t('options.formCompletion.label'),
          SERVICE_PRICES.SaisieFormulaire,
          t('options.formCompletion.tooltip')
        )}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={optionalServices.TraitementVIP}
            onChange={(e) => handleCheckboxChange(e, 'TraitementVIP')}
          />
        }
        label={renderLabelWithTooltip(
          t('options.vipTreatment.label'),
          SERVICE_PRICES.TraitementVIP,
          t('options.vipTreatment.tooltip')
        )}
      />
    </Box>
  );
};

export default OptionVisaComponent;
